import ApiCompanySite from 'types/api/CompanySite';

import Company from 'models/Company';
import CompanyBenefit from 'models/CompanyBenefit';
import CompanyDescription from 'models/CompanyDescription';
import CompanyImage from 'models/CompanyImage';
import FileUpload from 'models/FileUpload';
import Job from 'models/Job';
import JobBenefit from 'models/JobBenefit';
import JobCategory from 'models/JobCategory';
import Model from 'models/Model';

export enum Types {
    Size10 = '1-10',
    Size50 = '11-50',
    Size100 = '51-100',
    Size200 = '101-200',
    Size200plus = '>200',
}
export default class CompanySite implements Model {
    id: string;
    company: Company;
    isPublished: boolean;
    description: string;
    bgImage: FileUpload;
    logo: FileUpload;
    employeesCount: string;
    instagramUrl: string;
    facebookUrl: string;
    linkedinUrl: string;
    websiteUrl: string;
    companyImages: CompanyImage[];
    companyDescriptions: CompanyDescription[];
    companyBenefits: CompanyBenefit[];
    stagesDescription: string;
    jobs: Job[];
    jobCategory: JobCategory;

    constructor(data: ApiCompanySite) {
        this.id = data.id;
        this.company = data.company && new Company(data.company);
        this.isPublished = data.isPublished;
        this.description = data.description;
        this.bgImage = data.bgImage && new FileUpload(data.bgImage);
        this.logo = data.logo && new FileUpload(data.logo);
        this.employeesCount = data.employeesCount;
        this.instagramUrl = data.instagramUrl;
        this.facebookUrl = data.facebookUrl;
        this.linkedinUrl = data.linkedinUrl;
        this.websiteUrl = data.websiteUrl;
        this.companyImages = Array.isArray(data.companyImages)
            ? data.companyImages.map(image => new CompanyImage(image))
            : [];
        this.companyDescriptions = Array.isArray(data.companyDescriptions)
            ? data.companyDescriptions.map(description => new CompanyDescription(description))
            : [];
        this.companyBenefits = Array.isArray(data.companyBenefits)
            ? data.companyBenefits.map(benefit => new CompanyBenefit(benefit))
            : [];
        this.stagesDescription = data.stagesDescription;
        this.jobs = Array.isArray(data.jobs)
            ? data.jobs.map(job => new Job(job))
            : [];
        this.jobCategory = data.jobCategory && new JobCategory(data.jobCategory);
    }
}